import React from 'react';
import ScribePanel from '../scribe/ScribePanel';

/**
 * MobileScribeFAB - Mobile Floating Action Button for Scribe Panel
 * Provides mobile access to AI documentation features via FAB + modal
 */
const MobileScribeFAB = ({
  isOpen, onToggle, soapNote, transcript, speakerSegments, onUpdateNote,
  providerInfo, authData, activeTab, onTabChange, updateUrlWithTab, caseId
}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onToggle();
    }
  };
  return (
    <>
      {/* FAB Button */}
      <button
        className="mobile-fab"
        onClick={onToggle}
        title={isOpen ? 'Close Scribe Panel' : 'Open Scribe Panel'}
      >
        {isOpen ? '✕' : '📝'}
      </button>

      {/* Mobile Scribe Modal */}
      {isOpen && (
        <div
          className="mobile-toolbar-overlay"
          onClick={handleOverlayClick}
        >
          <div className="mobile-toolbar-container">
            {/* Close button */}
            <button
              className="modal-close-button"
              onClick={onToggle}
              title="Close"
            >
              ✕
            </button>

            {/* Scribe Panel */}
            <div className="mobile-scribe-content">
              <ScribePanel
                soapNote={soapNote}
                transcript={transcript}
                speakerSegments={speakerSegments}
                onUpdateNote={onUpdateNote}
                providerInfo={providerInfo}
                authData={authData}
                isAuthenticated={Boolean(authData)}
                activeTab={activeTab}
                onTabChange={onTabChange}
                updateUrlWithTab={updateUrlWithTab}
                caseId={caseId}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileScribeFAB;